import { ParticipantGender } from '@shared/models/participant.model';

export const VIA_SURVEY_ID: number = 86 as const;
export const VIA_SURVEY_QUESTION_COUNT: number = 120 as const;
export const VIA_SURVEY_API: string = 'https://www.viacharacter.org/survey/api1' as const;
export const VIA_SURVEY_LANGUAGE: string = 'en-us' as const;

export enum ViaSurveyEndpoint {
  getQuestions = 'GetQuestions',
  getResults = 'GetResults',
  loginUser = 'LoginUser',
  registerUser = 'RegisterUser',
  startSurvey = 'StartSurvey',
  submitAnswers = 'SubmitAnswers',
}

export const getViaSurveyEndpointUrl = (endpoint: ViaSurveyEndpoint): string => {
  return `${VIA_SURVEY_API}/${endpoint}`;
};

export interface ViaSurveyAnswerChoice {
  ChoiceID: number;
  Text: string;
}

export interface ViaSurveyQuestion {
  QuestionID: number;
  QuestionNumber: number;
  Text: string;
  AnswerChoices: ViaSurveyAnswerChoice[];
}

export interface Answer {
  questionID: number;
  choiceID: number;
}

export interface PayloadSubmitAnswer {
  appKey: string;
  loginKey: string;
  sessionkey: string;
  answers: Answer[];
}

export interface PayloadLoginRegister {
  appKey: string;
  sendWelcomeEmailToUser: false;
  email: string;
  firstName: 'Jeremy'; // Random name to not send the real first name to via survey
  lastName: 'Suliver'; // Random name to not send the real last name to via survey
  gender: ParticipantGender;
  password: string;
}
